module.exports = __webpack_public_path__ + "static/img/kaifa.9b06b92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaifa.jpg
// module id = DRtW
// module chunks = 1